export const LIST = {
  name: 'public-api.list',
  path: '/public-api',
};
